import Store from 'modules/state/Store';
import * as Actions from 'modules/state/recent/Actions';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';

let prefix = "";

if (App.context() != null && App.context().userTypeCode === "ADM") {
    prefix = "/admin";
}

const recentTypes = [
    {
        recentTypeCode: "user",
        iconName: "user",
        urlPattern: "/admin/userSetup/:id"
    }, {
        recentTypeCode: "help",
        iconName: "question-sign",
        urlPattern: "/admin/helpSetup/:id"
    }, {
        recentTypeCode: "news",
        iconName: "list-alt",
        urlPattern: "/admin/newsSetup/:id"
    }, {
        recentTypeCode: "termsAndConditions",
        iconName: "check-square-o",
        urlPattern: "/admin/termsAndConditionsSetup/:id"
    }, {
        recentTypeCode: "notification",
        iconName: "exclamation-sign",
        urlPattern: "/admin/notificationSetup/:id"
    }, {
        recentTypeCode: "role",
        iconName: "cog",
        urlPattern: "/admin/roleSetup/:id"
    }, {
        recentTypeCode: "search",
        iconName: "search",
        urlPattern: "/search?p=:id"
    }, {
        recentTypeCode: "account",
        iconName: "cog",
        urlPattern: "/admin/accountSetup/:id"
    }, {
        recentTypeCode: "import",
        iconName: "import",
        urlPattern: "/data/dataImport"
    }, {
        recentTypeCode: "UserSummaryReport",
        iconName: "export",
        urlPattern: "/reports/userReports"
    }, {
        recentTypeCode: "myProfile",
        iconName: "user",
        urlPattern: "/accounts/profile"
    }, {
        recentTypeCode: "customer",
        iconName: "lock",
        urlPattern: "/retail/customers/:id"
    }, {
        recentTypeCode: "product",
        iconName: "th-list",
        urlPattern: "/retail/products/:id"
    }, {
        recentTypeCode: "invoice",
        iconName: "usd",
        urlPattern: "/retail/invoices/:id"
    }, {
        recentTypeCode: "certification",
        iconName: "certificate",
        urlPattern: "/admin/certification/:id"
    }, {
        recentTypeCode: "company",
        iconName: "briefcase",
        urlPattern: "/manageCompany/:id"
    }, 
    {
        recentTypeCode: "sponsor",
        iconName: "link",
		urlPattern: prefix + "/sponsorSetup/:id"
    }, 
    {
        recentTypeCode: "connectToSponsors",
        iconName: "link",
        urlPattern: prefix + "/connectToSponsors/:id"
    }, 
    {
        recentTypeCode: "connectToVOB",
        iconName: "link",
        urlPattern: prefix + "/connectToVOB/:id"
    },
    {
        recentTypeCode: "NAICSCode",
        iconName: "th-list",
        urlPattern: "/admin/naicsCodeSetup/:id"
    },
    {
        recentTypeCode: "dd214",
        iconName: "link",
        urlPattern: "/admin/dd214Setup/:id"
    },
    {
        recentTypeCode: "emailingLog",
        iconName: "envelope",
        urlPattern: "/admin/emailingLog/:id"
    },
    {
        recentTypeCode: "emailTemplate",
        iconName: "tags",
        urlPattern: "/admin/emailingTemplateSetup/:id"
    },
    {
        recentTypeCode: "paypalInvoice",
        iconName: "usd",
        urlPattern: "/admin/paypalInvoiceSetup/:id"
    },
    {
        recentTypeCode: "tooltipManager",
        iconName: "info-sign",
        urlPattern: "/admin/tooltipManagerSetup/:id"
    }];

export const add = (recent) => {
    API.App.post('/recent/saveRecent', recent, {
        success: (sr) => {
            Store.dispatch(Actions.addRecent(recent));
        }
    },
        {
            block: false
        });
}

export const getTypes = () => {
    return recentTypes;
}



// WEBPACK FOOTER //
// ./src/modules/app/Recent.js